import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { IconInfo } from '@s4l/icons/IconInfo'
import { usePriceDetailsHelpers } from '../hooks'
import TaxFeesDetails from '../TaxFeesDetails'
import type { TaxDetail } from '../types'
import styles from './styles.module.css'

export interface PaymentRowProps {
  label: string
  amount: number | undefined
  currency: string | undefined
  withTaxDetails?: boolean
  taxDetails?: TaxDetail[]
  isNewExperimentVariant?: boolean
}

export default function PaymentRow({
  label,
  amount,
  currency,
  withTaxDetails,
  taxDetails,
  isNewExperimentVariant,
}: Readonly<PaymentRowProps>) {
  const { formatCurrency } = usePriceDetailsHelpers()

  return (
    <div className={styles.detailsRow}>
      {withTaxDetails && taxDetails ? (
        <TaxFeesDetails taxDetails={taxDetails} isNewExperimentVariant={isNewExperimentVariant}>
          <Button variant="text-flat" size="extraSmall" trailingIcon={<IconInfo size={16} />}>
            <Typography variant="body" size="l" bold>
              {label}
            </Typography>
          </Button>
        </TaxFeesDetails>
      ) : (
        <Typography variant="body" size="l">
          {label}
        </Typography>
      )}
      <Typography variant="body" size="l">
        {formatCurrency(amount, currency)}
      </Typography>
    </div>
  )
}
PaymentRow.displayName = 'PaymentRow'
